import React, { useEffect } from "react";
import styles from "./NotificationsPage.module.scss";
import Button from "../../components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { acceptOrRejectEmailRequest } from "../../reducer/requestEmailSlice";
import { getTimeAgo, serverFiles } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import { readNotifications } from "reducer/notificationSlice";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import InfiniteEndMessage from "components/InfiniteEndMessage/InfiniteEndMessage";
import no_notifications_img from "../../images/errorImages/noNotifcations.png";

const NotificationsPage = ({ setShowRedDot, onClose }) => {
  // const [page, setPage] = useState(0);
  // const size = 1;
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { notifications, isLoading } = useSelector(
    (state) => state.notifications
  );

  //Function call when user accepts or rejects the email request sent by others.
  const updateStatus = async (status, id) => {
    const payload = {
      userAliasId: id,
      status,
    };
    try {
      const res = await dispatch(acceptOrRejectEmailRequest(payload));
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  //Function call to mark all the unread notifications to read and sent it to backend.
  const markUnreadToRead = () => {
    let readNotificationsIdList = notifications.map((notification) => {
      if (!notification?.isRead) {
        return notification?.id;
      }
    });
    return readNotificationsIdList;
  };

  let notificationIds = markUnreadToRead();
  useEffect(() => {
    dispatch(readNotifications(notificationIds));
    setShowRedDot(false);
  }, []);

  return (
    <div style={{}} className={styles.notifications_page_main}>
      <section className={styles.notifications_cards}>
        {isLoading && (
          <div className={styles.loaderContainer}>
            <SpinnerLoader />
          </div>
        )}
        {!isLoading && notifications?.length === 0 && (
          <div className={styles.no_notifications}>
            <img
              src={no_notifications_img}
              alt=""
              className={styles.no_notifications_img}
            />
            <p className={styles.no_notifications_text}>No notifications yet</p>

            <Button
              variant="filled"
              onClick={() => {
                onClose();
                navigate("/feed");
              }}
            >
              Go to Feed
            </Button>
          </div>
        )}
        {!isLoading &&
          notifications?.map((notification, index) => (
            <div className={styles.notification_card} key={index}>
              <div className={styles.notification_left}>
                <img
                  src={serverFiles(
                    notification?.actionUserDto?.actionUserProfileUrl
                  ) || NO_IMAGE}
                  alt="profilepic"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = NO_IMAGE;
                  }}
                  onClick={() =>
                    (window.location.href = `/user-profile/${notification?.actionUserDto?.actionUserAliasId}`)
                  }
                />
                <Link
                  to={
                    notification?.actiontype === "LIKE"
                      ? `/posts/${notification?.postId}`
                      : `/user-profile/${notification?.actionUserDto?.actionUserAliasId}`
                  }
                >
                  <p className={styles.notification_details}>
                    {" "}
                    {notification?.message}{" "}
                  </p>

                  <p className={styles.notification_time_uploaded}>
                    {getTimeAgo(notification?.createdAt)}
                    {/* {" ago"} */}
                  </p>
                </Link>
              </div>

              {/* Show Button Accept or Reject Buttons only in the case of Email request */}
              {notification.actiontype === "CONNECT" && (
                <div className={styles.notification_request_buttons}>
                  <Button
                    onClick={() =>
                      updateStatus(
                        "ACCEPT",
                        notification?.actionUserDto?.actionUserAliasId
                      )
                    }
                    variant={"filled"}
                    disabled={
                      notification?.connectionStatus === "ACCEPT" ||
                      notification?.connectionStatus === "REJECT"
                    }
                  >
                    Accept
                  </Button>
                  <Button
                    onClick={() =>
                      updateStatus(
                        "REJECT",
                        notification?.actionUserDto?.actionUserAliasId
                      )
                    }
                    variant={"outlined"}
                    disabled={
                      notification?.connectionStatus === "ACCEPT" ||
                      notification?.connectionStatus === "REJECT"
                    }
                  >
                    Reject
                  </Button>
                </div>
              )}
            </div>
          ))}

        {notifications?.length > 0 && (
          <InfiniteEndMessage message="No more notifications" />
        )}
      </section>
    </div>
  );
};

export default NotificationsPage;
